import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField4 } from "../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router-dom";

//Components
import Layout from "../../../Layout/Layout";

//API
import ItemService from "../../../services/supplier_appCommonService";
import toast from "react-hot-toast";

const AdvancePaymentDetails = () => {
  const location = useLocation();
  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Payment");

  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [itemRows, setItemRows] = useState([]);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isPaymentFromToVisible, setPaymentFromToVisible] = useState(true);
  const [isAccountsVisible, setAccountsVisible] = useState(true);
  const [isAmountVisible, setAmountVisible] = useState(true);
  const [isItemsVisible, setItemsVisible] = useState(true);
  const [isWriteOffVisible, setWriteOffVisible] = useState(true);
  const [isTransactionsVisible, setTransactionsVisible] = useState(true);

  const [formData, setFormData] = useState({
    paymentType: "",
    postingDate: "",
    company: "",
    partyType: "",
    partyName: "",
    party: "",
    partyBalance: "",
    accountPaidTo: "",
    accountPaidFrom: "",
    accountCurrency1: "INR",
    accountCurrency2: "INR",
    amount: "",
    paidAmount: "",
    totalAllocatedAmount: "0.00",
    allocatedAmount: "",
    differenceAmount: "0.00",
    chequeRefNo: "",
    chequeRefDate: "",
    paymentMode: "",
  });

  // Options
  const paymentTypeOptions = [
    { id: 1, name: "Receive", value: "Receive" },
    { id: 2, name: "Pay", value: "Pay" },
  ];

  const partyTypeOptions = [
    { id: 1, name: "Customer", value: "Customer" },
    { id: 2, name: "Supplier", value: "Supplier" },
  ];

  const paymentModeOptions = [
    { id: 1, name: "Cash", value: "Cash" },
    { id: 2, name: "Cheque", value: "Cheque" },
    { id: 3, name: "NEFT", value: "NEFT" },
    { id: 4, name: "RTGS", value: "RTGS" },
    { id: 5, name: "UPI", value: "UPI" },
  ];


  // ─── DYNAMIC DROPDOWN OPTIONS ────────────────────────────────────────
  const [companyOptions, setCompanyOptions] = useState([]);
  // Manual entry status tracking
  const [isManualPaidFrom, setIsManualPaidFrom] = useState(false);
  const [isManualPaidTo, setIsManualPaidTo] = useState(false);
  // eslint-disable-next-line 
  const [supplierBankOptions, setSupplierBankOptions] = useState([]);
  // eslint-disable-next-line 
  const [bankAccountOptions, setBankAccountOptions] = useState([]);


  // FETCH COMPANY LIST
  const fetchCompanyList = async () => {
    try {
      const response = await ItemService.generateCustomerQuery({
        queryName: "Get_CompanyMaster_ActiveList",
      });
      if (response?.status === 200 && response.data) {
        const companies = response.data.map((c) => ({
          id: c.code,
          name: c.name,
          code: c.code,
          organisationName: c.organisationName,
          city: c.city,
        }));
        setCompanyOptions(companies);
      }
    } catch (error) {
      console.error("Error fetching company list:", error);
    } finally {
    }
  };

  // FETCH SUPPLIER LIST
  const fetchSupplierList = async () => {
    try {
      const response = await ItemService.generateQuery({
        queryName: "getRegisteredSupplierList",
      });
      if (response?.status === 200 && response.data) {
      }
    } catch (error) {
      console.error("Error fetching supplier list:", error);
    } finally {
    }
  };

  // FETCH CUSTOMER LIST
  const fetchCustomerList = async () => {
    try {
      const response = await ItemService.generateCustomerQuery({
        queryName: "getCustomerListC04",
        module: "CUSTOMER",
      });
      if (response?.status === 200 && response.data) {

      }
    } catch (error) {
      console.error("Error fetching customer list:", error);
    } finally {

    }
  };


  /** Safely coerce a value to a number (returns 0 for empty/invalid) */
  const toNum = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  };

  // Fetch advance payment detail
  const fetchAdvancePaymentDetail = async (documentNumber) => {
    try {
      setLoading(true);
      const response = await ItemService.generateQuery({
        queryName: "getAdvancePaymentDetail",
        documentNumber: documentNumber,
      });

      if (
        response?.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const data = response.data[0];
        setDetailData(data);
        setOriginalData(data);

        // Set form data (with IDs for dynamic lookup)
        setFormData({
          paymentType: data.paymentType || "",
          postingDate: data.postingDate || "",
          company: data.company || "",
          partyType: data.partyType || "",
          partyName: data.partyName || "",
          party: data.party || "",
          partyBalance: data.partyBalance?.toString() || "",
          accountPaidFrom: data.accountPaidFrom || "",
          accountPaidTo: data.accountPaidTo || "",
          accountCurrency1: data.accountCurrency1 || "INR",
          accountCurrency2: data.accountCurrency2 || "INR",
          amount: data.amount?.toString() || "",
          paidAmount: data.paidAmount?.toString() || "",
          totalAllocatedAmount: data.totalAllocatedAmount?.toString() || "0.00",
          allocatedAmount: data.allocatedAmount?.toString() || "0.00",
          differenceAmount: data.differenceAmount?.toString() || "0.00",
          chequeRefNo: data.chequeRefNo || "",
          chequeRefDate: data.chequeRefDate ? data.chequeRefDate.split("T")[0] : "",
          paymentMode: data.paymentMode || "",
        });

        // Set items
        if (data.items && data.items.length > 0) {
          setItemRows(data.items);
        }

      } else {
        toast.error("Advance Payment not found");
        window.location.href = "/supplier_app/finance/advance-payment-list";
      }
    } catch (error) {
      console.error("Error fetching advance payment detail:", error);
      toast.error("Failed to load Advance Payment details");
    } finally {
      setLoading(false);
    }
  };

  // RECOMPUTE totals whenever items or paidAmount changes
  useEffect(() => {
    let totalAlloc = 0;
    itemRows?.forEach((row) => {
      totalAlloc += toNum(row.allocated);
    });
    setFormData((prev) => ({
      ...prev,
      totalAllocatedAmount: totalAlloc.toString(),
      differenceAmount: (toNum(prev.paidAmount) - totalAlloc).toFixed(2).toString(),
    }));
  }, [itemRows, formData.paidAmount]);

  // Fetch on mount
  useEffect(() => {
    fetchCompanyList();
    fetchSupplierList();
    fetchCustomerList();

    const documentNumber = location.state?.documentNumber;
    if (documentNumber) {
      fetchAdvancePaymentDetail(documentNumber);
    } else {
      toast.error("No document number provided");
      window.location.href = "/supplier_app/finance/advance-payment-list";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Edit mode handlers
  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleCancel = () => {
    // Revert to original data
    if (originalData) {
      setFormData({
        paymentType: originalData.paymentType || "",
        postingDate: originalData.postingDate || "",
        company: originalData.company || "",
        partyType: originalData.partyType || "",
        partyName: originalData.partyName || "",
        party: originalData.party || "",
        partyBalance: originalData.partyBalance?.toString() || "",
        accountPaidTo: originalData.accountPaidTo || "",
        accountPaidFrom: originalData.accountPaidFrom || "",
        accountCurrency1: originalData.accountCurrency1 || "INR",
        accountCurrency2: originalData.accountCurrency2 || "INR",
        amount: originalData.amount?.toString() || "",
        paidAmount: originalData.paidAmount?.toString() || "",
        totalAllocatedAmount: originalData.totalAllocatedAmount || "0.00",
        allocatedAmount: originalData.allocatedAmount || "",
        differenceAmount: originalData.differenceAmount || "0.00",
        chequeRefNo: originalData.chequeRefNo || "",
        chequeRefDate: originalData.chequeRefDate || "",
        paymentMode: originalData.paymentMode || "",
      });
      setItemRows(originalData.items || []);
    }
    setIsEditMode(false);
  };

  const handleUpdate = async () => {
    // Get document number
    const documentNumber =
      detailData?.documentNumber || detailData?.advancePaymentRequestNr;
    if (!documentNumber) {
      toast.error("Document number not found");
      return;
    }

    // Comprehensive validation
    const errors = [];
    if (!formData.paymentType) errors.push("Payment Type is required");
    if (!formData.postingDate) errors.push("Posting Date is required");
    if (!formData.company) errors.push("Company is required");
    if (!formData.paidAmount) errors.push("Paid Amount is required");

    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return;
    }

    // Prepare payload with documentNumber
    const payload = {
      documentNumber: documentNumber,
      data: {
        ...formData,
        items: itemRows.map((row) => ({
          ...row,
          totalAmount: toNum(row.totalAmount),
          outstanding: toNum(row.outstanding),
          allocated: toNum(row.allocated),
        })),
        totalAllocatedAmount: toNum(formData.totalAllocatedAmount),
        differenceAmount: toNum(formData.differenceAmount),
      },
    };

    try {
      const response = await ItemService.updateAdvancePaymentRequest(payload);
      if (response?.status === 200 || response?.status === 201) {
        toast.success("Advance Payment updated successfully!");
        setIsEditMode(false);
        // Refresh data
        fetchAdvancePaymentDetail(
          detailData.documentNumber || detailData.advancePaymentRequestNr,
        );
      } else {
        toast.error(response?.message || "Failed to update Advance Payment");
      }
    } catch (error) {
      console.error("Error updating Advance Payment:", error);
      toast.error("Failed to create Advance Payment");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleComboChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...itemRows];
    updated[index][field] = value;
    setItemRows(updated);
  };

  const handleAddItem = () => {
    const newRow = {
      slNo: itemRows.length + 1,
      type: "",
      name: "",
      totalAmount: "",
      outstanding: "",
      allocated: "",
    };
    setItemRows([...itemRows, newRow]);
  };

  const handleDeleteItem = (index) => {
    const updated = itemRows
      .filter((_, i) => i !== index)
      .map((row, i) => ({
        ...row,
        slNo: i + 1,
      }));
    setItemRows(updated);
  };

  const toggleCardVisibility = () => setCardVisible(!isCardVisible);
  const togglePaymentFromToVisibility = () =>
    setPaymentFromToVisible(!isPaymentFromToVisible);
  const toggleAccountsVisibility = () => setAccountsVisible(!isAccountsVisible);
  const toggleAmountVisibility = () => setAmountVisible(!isAmountVisible);
  const toggleItemsVisibility = () => setItemsVisible(!isItemsVisible);
  const toggleWriteOffVisibility = () => setWriteOffVisible(!isWriteOffVisible);
  const toggleTransactionsVisibility = () =>
    setTransactionsVisible(!isTransactionsVisible);

  // Item columns (conditional based on edit mode)
  const itemColumns = isEditMode
    ? [
        {
          name: "Sl.No",
          selector: (row) => row.slNo,
          width: "70px",
        },
        {
          name: "Type",
          cell: (row, index) => (
            <select
              className="inputBox mb-0 form-select"
              value={row.type}
              onChange={(e) => handleItemChange(index, "type", e.target.value)}
              style={{ minWidth: "100px" }}
            >
              <option value="">Select</option>
              <option value="PO">PO</option>
              <option value="Invoice">Invoice</option>
            </select>
          ),
          ignoreRowClick: true,
          button: true,
          width: "120px",
        },
        {
          name: "Item Name",
          cell: (row, index) => (
            <input
              type="text"
              className="inputBox mb-0 form-control"
              value={row.name}
              onChange={(e) => handleItemChange(index, "name", e.target.value)}
            />
          ),
          ignoreRowClick: true,
          button: true,
          width: "150px",
        },
        {
          name: "Total Amount (INR)",
          cell: (row, index) => (
            <input
              type="number"
              className="inputBox mb-0 form-control"
              value={row.totalAmount}
              onChange={(e) =>
                handleItemChange(index, "totalAmount", e.target.value)
              }
            />
          ),
          ignoreRowClick: true,
          button: true,
          width: "150px",
        },
        {
          name: "Outstanding (INR)",
          cell: (row, index) => (
            <input
              type="number"
              className="inputBox mb-0 form-control"
              value={row.outstanding}
              onChange={(e) =>
                handleItemChange(index, "outstanding", e.target.value)
              }
            />
          ),
          ignoreRowClick: true,
          button: true,
          width: "150px",
        },
        {
          name: "Allocated (INR)",
          cell: (row, index) => (
            <input
              type="number"
              className="inputBox mb-0 form-control"
              value={row.allocated}
              onChange={(e) =>
                handleItemChange(index, "allocated", e.target.value)
              }
            />
          ),
          ignoreRowClick: true,
          button: true,
          width: "150px",
        },
        {
          name: "Action",
          cell: (row, index) => (
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteItem(index)}
              title="Delete"
            >
              <i className="bi bi-trash"></i>
            </button>
          ),
          width: "80px",
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
        },
      ]
    : [
        {
          name: "Sl.No",
          selector: (row) => row.slNo,
          width: "70px",
        },
        {
          name: "Type",
          selector: (row) => row.type || "--",
          width: "100px",
        },
        {
          name: "Item Name",
          selector: (row) => row.name || "--",
          width: "150px",
        },
        {
          name: "Total Amount (INR)",
          cell: (row) => (
            <span className="fw-bold">
              {row.totalAmount
                ? `₹ ${Number(row.totalAmount).toLocaleString("en-IN")}`
                : "--"}
            </span>
          ),
          width: "150px",
        },
        {
          name: "Outstanding (INR)",
          cell: (row) => (
            <span>
              {row.outstanding
                ? `₹ ${Number(row.outstanding).toLocaleString("en-IN")}`
                : "--"}
            </span>
          ),
          width: "150px",
        },
        {
          name: "Allocated (INR)",
          cell: (row) => (
            <span style={{ color: "#0d6efd", fontWeight: "bold" }}>
              {row.allocated
                ? `₹ ${Number(row.allocated).toLocaleString("en-IN")}`
                : "--"}
            </span>
          ),
          width: "150px",
        },
      ];

  const renderAccordionHeader = (isVisible, toggle, icon, title, subtitle) => (
    <h2 className="accordion-header">
      <Row className="accordion-button">
        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
          <i
            className={`bi ${isVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
            onClick={toggle}
          ></i>
        </Col>
        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
          <span className="iconLogo">{icon}</span>
        </Col>
        <Col xs={12} md={9} lg={9}>
          <span className="headerTitle">{title}</span>
          {subtitle && <span className="subHeaderTitle">{subtitle}</span>}
        </Col>
      </Row>
    </h2>
  );

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // Format amount for display
  const formatAmount = (amount) => {
    if (!amount) return "";
    return Number(amount).toLocaleString("en-IN");
  };

  // Show cheque/reference fields only when payment mode is not Cash
  const showChequeFields = formData.paymentMode && formData.paymentMode !== "Cash";

  if (loading) {
    return (
      <main className="dashboard main" id="main">
        <Layout />
        <Row className="justify-center subContent">
          <Col xs={12} md={12} className="rightSide">
            <div
              className="rightSideInner PageCommonCSS d-flex justify-content-center align-items-center"
              style={{ minHeight: "400px" }}
            >
              <div className="text-center">
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>
                <p className="mt-3">Loading Advance Payment details...</p>
              </div>
            </div>
          </Col>
        </Row>
      </main>
    );
  }

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            {/* Header with Title and Action Buttons */}
            <Row className="mb-3">
              <Col xs={12} md={6} lg={6}>
                <h2 className="mainTitle">Advance Payment Details</h2>
                <p className="subText">
                  Document No:{" "}
                  <strong>
                    {detailData?.documentNumber ||
                      detailData?.advancePaymentRequestNr ||
                      "--"}
                  </strong>
                </p>
              </Col>
            </Row>
            <hr />

            <Row className="mb-2">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-arrow-left"></i> Back
                </button>
              </Col>
              {!isEditMode ? (
                <Col
                  xs={12}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className=""
                >
                  <button className="btnTable" onClick={handleEdit}>
                    <i className="bi bi-pencil"></i> Edit
                  </button>
                </Col>
              ) : (
                <>
                  <Col
                    xs={12}
                    md={{ span: 2, offset: 6 }}
                    lg={{ span: 2, offset: 6 }}
                    className=""
                  >
                    <button className="btnTable me-2" onClick={handleCancel}>
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </Col>
                  <Col xs={12} md={2} lg={2} className="">
                    <button className="btnApprove" onClick={handleUpdate}>
                      <i className="bi bi-save"></i> Update
                    </button>
                  </Col>
                </>
              )}
            </Row>
            {/* 1. Type of Payment */}
            <div className="accordion mb-4" id="accordionPaymentType">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isCardVisible,
                  toggleCardVisibility,
                  "AP",
                  "1. Type of Payment",
                  "Payment Type, Posting Date and Company",
                )}
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {false ? (
                          <ComboboxField4
                            label="a. Payment type"
                            placeholder="Select Payment Type"
                            data={paymentTypeOptions}
                            value={formData.paymentType}
                            onChange={(val) =>
                              handleComboChange("paymentType", val)
                            }
                          />
                        ) : (
                          <InputField
                            label="a. Payment type"
                            type="text"
                            name="paymentType"
                            className="inputBox"
                            value={formData.paymentType}
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="b. Posting Date"
                          type="date"
                          name="postingDate"
                          className="inputBox"
                          value={formatDate(formData.postingDate)}
                          onChange={handleInputChange}
                          // disabled={!isEditMode}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {isEditMode ? (
                          <ComboboxField4
                            label="Company"
                            placeholder="Select Company"
                            data={companyOptions}
                            value={formData.company}
                            onChange={(val) =>
                              handleComboChange("company", val)
                            }
                            disabled={true}
                          />
                        ) : (
                          <InputField
                            label="Company"
                            type="text"
                            name="company"
                            className="inputBox"
                            value={formData.company}
                            disabled={true}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 2. Payment from/To */}
            <div className="accordion mb-4" id="accordionPaymentFromTo">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isPaymentFromToVisible,
                  togglePaymentFromToVisibility,
                  "PF",
                  "2. Payment from/To",
                  "Party Type, Party Name and Party",
                )}
                <div
                  className={`accordion-collapse collapse show ${isPaymentFromToVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {isEditMode ? (
                          <ComboboxField4
                            label="a. Party type"
                            placeholder="Select Party Type"
                            data={partyTypeOptions}
                            value={formData.partyType}
                            onChange={(val) =>
                              handleComboChange("partyType", val)
                            }
                            disabled={true}
                          />
                        ) : (
                          <InputField
                            label="a. Party type"
                            type="text"
                            name="partyType"
                            className="inputBox"
                            value={formData.partyType}
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="b. Party Name"
                          type="text"
                          name="partyName"
                          className="inputBox"
                          value={formData.partyName}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="c. Party"
                          type="text"
                          name="party"
                          className="inputBox"
                          value={formData.party}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Accounts */}
            <div className="accordion mb-4" id="accordionAccounts">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isAccountsVisible,
                  toggleAccountsVisibility,
                  "AC",
                  "Accounts",
                  "",
                )}
                <div
                  className={`accordion-collapse collapse show ${isAccountsVisible ? "visible" : ""}`}
                >
                      <div className="accordion-body">
                      {(() => {
                        const isPay = formData.paymentType === "Pay";
                        const dropdownLabel = isPay
                          ? "Account Paid From (Company Bank/Cash)"
                          : "Account Paid To (Company Bank/Cash)";
                        const readonlyLabel = isPay
                          ? "Account Paid To (Party Ledger)"
                          : "Account Paid From (Party Ledger)";

                        return (
                          <Row className="pt-2">
                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              <InputField
                                label="a. Party balance (INR)"
                                type="text"
                                name="partyBalance"
                                className="inputBox"
                                value={formatAmount(formData.partyBalance)}
                                disabled={true}
                              />
                            </Col>

                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              {isEditMode ? (
                                <ComboboxField4
                                  label={isPay ? "b. " + dropdownLabel : "c. " + dropdownLabel}
                                  placeholder="Select Account"
                                  data={bankAccountOptions}
                                  value={isPay ? formData.accountPaidFrom : formData.accountPaidTo}
                                  onChange={(val) => {
                                      handleComboChange(isPay ? "accountPaidFrom" : "accountPaidTo", val);
                                      if(val !== "Manual Entry") {
                                         if(isPay) setIsManualPaidFrom(false);
                                         else setIsManualPaidTo(false);
                                      } else {
                                         if(isPay) setIsManualPaidFrom(true);
                                         else setIsManualPaidTo(true);
                                      }
                                  }}
                                />
                              ) : (
                                <InputField
                                  label={isPay ? "b. " + dropdownLabel : "c. " + dropdownLabel}
                                  type="text"
                                  name={isPay ? "accountPaidFrom" : "accountPaidTo"}
                                  className="inputBox"
                                  value={isPay ? formData.accountPaidFrom : formData.accountPaidTo}
                                  disabled={true}
                                />
                              )}
                            </Col>

                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              {isEditMode ? (
                                <ComboboxField4
                                  label={isPay ? "b. " + readonlyLabel : "c. " + readonlyLabel}
                                  placeholder="Select Account"
                                  data={formData.partyType === "Supplier" ? supplierBankOptions : [{id: "party-ledger", name: "Party Ledger", value: "Party Ledger"}]}
                                  value={formData.accountPaidTo || formData.accountPaidFrom} // Logic simplified; ensure this retrieves correct side account
                                  onChange={(val) => {
                                      handleComboChange(isPay ? "accountPaidTo" : "accountPaidFrom", val);
                                      if(val !== "Manual Entry") {
                                         if(isPay) setIsManualPaidTo(false);
                                         else setIsManualPaidFrom(false);
                                      } else {
                                         if(isPay) setIsManualPaidTo(true);
                                         else setIsManualPaidFrom(true);
                                      }
                                  }}
                                />
                              ) : (
                                <InputField
                                  label={isPay ? "b. " + readonlyLabel : "c. " + readonlyLabel}
                                  type="text"
                                  name={isPay ? "accountPaidTo" : "accountPaidFrom"}
                                  className="inputBox"
                                  value={isPay ? formData.accountPaidTo : formData.accountPaidFrom}
                                  disabled={true}
                                />
                              )}
                            </Col>

                            {/* Manual Entry Fields */}
                            {isManualPaidFrom && (
                                <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                    <InputField
                                        label={isPay ? "b. Account Paid From (Manual Entry)" : "c. Account Paid From (Manual Entry)"}
                                        type="text"
                                        name="accountPaidFrom"
                                        className="inputBox"
                                        value={formData.accountPaidFrom}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            )}
                            {isManualPaidTo && (
                                <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                    <InputField
                                        label={isPay ? "b. Account Paid To (Manual Entry)" : "c. Account Paid To (Manual Entry)"}
                                        type="text"
                                        name="accountPaidTo"
                                        className="inputBox"
                                        value={formData.accountPaidTo}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                            )}

                          </Row>
                        );
                      })()}
                      <Row className="pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="d. Account currency"
                          type="text"
                          name="accountCurrency1"
                          className="inputBox"
                          value={formData.accountCurrency1}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="e. Account Currency"
                          type="text"
                          name="accountCurrency2"
                          className="inputBox"
                          value={formData.accountCurrency2}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Amount */}
            <div className="accordion mb-4" id="accordionAmount">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isAmountVisible,
                  toggleAmountVisibility,
                  "AM",
                  "Amount",
                  "",
                )}
                <div
                  className={`accordion-collapse collapse show ${isAmountVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="Amount"
                          type="text"
                          name="amount"
                          className="inputBox"
                          value={formData.amount}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="Paid Amount (INR)"
                          type="text"
                          name="paidAmount"
                          className="inputBox"
                          value={formData.paidAmount}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Add Item Button (only in edit mode) */}
            {isEditMode && (
              <Row className="mb-4">
                <Col xs={12} md={2} lg={2} className="">
                  <button className="btnTable me-2" onClick={handleAddItem}>
                    <i className="bi bi-plus-circle"></i> Add Item
                  </button>
                </Col>
              </Row>
            )}

            {/* Items */}
            <div className="accordion mb-4" id="accordionItems">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isItemsVisible,
                  toggleItemsVisibility,
                  "IT",
                  "Items",
                  "",
                )}
                <div
                  className={`accordion-collapse collapse show ${isItemsVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <div className="table-responsive pt-2 pb-4">
                      <DataTable
                        columns={itemColumns}
                        data={itemRows}
                        noHeader
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Write off */}
            <div className="accordion mb-4" id="accordionWriteOff">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isWriteOffVisible,
                  toggleWriteOffVisibility,
                  "WO",
                  "Write off",
                  "",
                )}
                <div
                  className={`accordion-collapse collapse show ${isWriteOffVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="a. Total allocated amount (INR)"
                          type="text"
                          name="totalAllocatedAmount"
                          className="inputBox"
                          value={formData.totalAllocatedAmount}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          label="b. Allocated Amount"
                          type="text"
                          name="allocatedAmount"
                          className="inputBox"
                          value={formData.allocatedAmount}
                          onChange={handleInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div className="w-100">
                          <label className="form-label fw-bold">
                            Difference Amount (INR)
                          </label>
                          <div
                            className="inputBox px-3 py-2"
                            style={{
                              background: "#e9ecef",
                              borderRadius: "4px",
                              color:
                                formData.differenceAmount === "0.00"
                                  ? "#198754"
                                  : "#dc3545",
                              fontWeight: "bold",
                              border: "1px solid #ced4da",
                            }}
                          >
                            {`₹ ${formData.differenceAmount}`}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Transactions */}
            <div className="accordion mb-4" id="accordionTransactions">
              <div className="accordion-item">
                {renderAccordionHeader(
                  isTransactionsVisible,
                  toggleTransactionsVisibility,
                  "TR",
                  "Transactions",
                  "",
                )}
                <div
                  className={`accordion-collapse collapse show ${isTransactionsVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {isEditMode ? (
                          <ComboboxField4
                            label="Payment Mode"
                            placeholder="Select Payment Mode"
                            data={paymentModeOptions}
                            value={formData.paymentMode}
                            onChange={(val) =>
                              handleComboChange("paymentMode", val)
                            }
                          />
                        ) : (
                          <InputField
                            label="Payment Mode"
                            type="text"
                            name="paymentMode"
                            className="inputBox"
                            value={formData.paymentMode}
                            disabled={true}
                          />
                        )}
                      </Col>
                      {showChequeFields && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              label={`${formData.paymentMode} / Reference No`}
                              type="text"
                              name="chequeRefNo"
                              className="inputBox"
                              placeholder={`Enter ${formData.paymentMode} No`}
                              value={formData.chequeRefNo}
                              onChange={handleInputChange}
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              label={`${formData.paymentMode} / Reference Date`}
                              type="date"
                              name="chequeRefDate"
                              className="inputBox"
                              value={formatDate(formData.chequeRefDate)}
                              onChange={handleInputChange}
                              disabled={!isEditMode}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* <Row className="mb-2">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-arrow-left"></i> Back
                </button>
              </Col>
              {!isEditMode ? (
                <Col
                  xs={12}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className=""
                >
                  <button className="btnTable" onClick={handleEdit}>
                    <i className="bi bi-pencil"></i> Edit
                  </button>
                </Col>
              ) : (
                <>
                  <Col
                    xs={12}
                    md={{ span: 2, offset: 6 }}
                    lg={{ span: 2, offset: 6 }}
                    className=""
                  >
                    <button className="btnTable me-2" onClick={handleCancel}>
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </Col>
                  <Col xs={12} md={2} lg={2} className="">
                    <button className="btnApprove" onClick={handleUpdate}>
                      <i className="bi bi-save"></i> Update
                    </button>
                  </Col>
                </>
              )}
            </Row> */}
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default AdvancePaymentDetails;
